

export const widgetsComments: CommonWidget = {

  /**************************************************************************
   *                                COMMENTS
  ***************************************************************************/
  lastComments: {
    title: 'Últimos comentarios',
    position: [0, 23],
    size: [4, 2],
    config: {
      id: 'last-five-comments',
      type: 'comments',
      indicators: [
        {
          indicator: 'comments',
          keyExtract: [
            'comment',
            'createdAt',
            'criticalMoment',
            'criticalMomentDescription',
            'count',
            'geoLocation',
            'surveyResponseId',
            'geoLocationDescription',
            'type',  // <-- Vital para nuestro cadenero
            'score', // <-- Vital para el cadenero y el orden
          ],
          singleton: true,
          extras: {},
        },
      ],
    },
  },

  lastCommentsTable: {
    title: 'Últimos comentarios',
    position: [0, 23],
    size: [4, 2],
    config: {
      id: 'last-five-comments',
      type: 'commentsTable',
      indicators: [
        {
          indicator: 'comments',
          keyExtract: [
            'comment',
            'createdAt',
            'criticalMoment',
            'criticalMomentDescription',
            'count', 
            'geoLocation',
            'surveyResponseId',
            'geoLocationDescription',
            'type',  // <-- Vital para nuestro cadenero
            'score', // <-- Vital para el cadenero y el orden
          ],
          singleton: true,
          extras: {},
        },
      ],
    },
  },

}
